const getParameters = async () => {
    try {
        const url = window.location.href;
        const isLocalhost = url.includes('localhost') || url.includes('pci.dev.bpimsapps.com');
        const [, stage, , flag] = url.split('.');

        let endpoint = `https://partners-api.${flag ? `${stage}.` : ''}bpimsapps.com/data/get`;

        if (isLocalhost) {
            endpoint = 'https://partners-api.dev.bpimsapps.com/data/get';
        }

        const response = await fetch(endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ tables: ['parameters'] })
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        return data.data;
    } catch (error) {
        console.error('getParameters api error', error);
        throw error;
    }
};

export default getParameters;
